import { AppContext } from 'config/enums'

import { pfLanguages } from './pf'
import { pjLanguages } from './pj'
import { iaLanguages } from './ia'
import { arLanguages } from './ar'
import { usLanguages } from './ub'

export const languages = {
  [AppContext.PF]: pfLanguages,
  [AppContext.PJ]: pjLanguages,
  [AppContext.IA]: iaLanguages,
  [AppContext.AR]: arLanguages,
  [AppContext.UB]: usLanguages,
}
